module.exports = __webpack_public_path__ + "static/media/KG.f3a910af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/KG.svg
// module id = 2183
// module chunks = 7